import { Fade, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import React, { useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom";
import MDBox from "components/MDBox";

function UserActions({ user }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(null);
  };

  const handleTemplateEdit = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(null);
    navigate(`/coach/templates/user/edit/${user.id}`);
  };

  return (
    <>
      <MDBox sx={{ display: "flex", cursor: "pointer", fontSize: "1.25rem" }} onClick={handleClick}>
        <MenuIcon />
      </MDBox>
      <Menu
        open={open}
        onClose={handleClose}
        anchorEl={anchorEl}
        keepMounted
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        TransitionComponent={Fade}
      >
        <MenuItem onClick={handleTemplateEdit}>
          <ListItemIcon>
            <EditIcon />
          </ListItemIcon>
          <ListItemText sx={{ "& .MuiTypography-root ": { fontSize: "16px" } }}>
            Edit Template
          </ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
}

export default UserActions;
